import React from 'react'
import {plansData} from '../../data/plansData';
import whiteTick from '../../assets/whiteTick.png' 
import rightArrow from '../../assets/rightArrow.png'
import './Plans.css';

const Plans = () => {
  return (
    <div className="plans-container" id='Plans'>
        <div className="blur plans-blur-1"></div>
        <div className="blur plans-blur-2"></div>
        <div className="programs-header" style={{gap: '2rem'}}>
            <span className='stroke-text'>READY TO START</span>
            <span>YOUR JOURNEY</span>
            <span className='stroke-text'>NOW WITHUS</span>
        </div>

        {/*plans card*/}
        <div className="plans">
            {plansData.map((plan, i)=> (
                <div className="plan" key={i}>
                    {plan.icon}
                    <span>{plan.name} </span>
                    <span>$ {plan.price} </span>

                    <div className="feacrures">
                        {plan.features.map((feacture, i)=> (
                            <div className="feacture" >
                                <img src={whiteTick} alt="" />
                                <span key={i}>{feacture} </span>
                            </div>
                        ))}
                    </div>

                    <div >
                        <span>Seen more benefits <img src={rightArrow} alt="" className='arrow'/> </span>
                    </div>
                    <button className='btn'> Join Now</button>
                </div>
            ))}
        </div>
    </div>
  )
}

export default Plans